export default __webpack_public_path__ + "static/media/car.03163ba3.svg";